// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as Future from "rescript-future/lib/es6/src/Future.res.js";
import * as LumiReact from "./LumiReact.res.js";
import * as LumiOption from "./LumiOption.res.js";
import * as LumiResult from "./LumiResult.res.js";
import * as LumiString from "./LumiString.res.js";
import * as FuturePromise from "rescript-future/lib/es6/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as JsCookieJs from "lumi-rescript/src/js-cookie.js";

function toString(err) {
  let shorten = str => {
    let parts = str.split(" ");
    if (parts.length <= 3) {
      return str;
    } else {
      return parts[0] + " (...) " + parts[parts.length - 1 | 0];
    }
  };
  if (typeof err !== "object") {
    if (err === "NoXSRFTokenCookie") {
      return `No XSRF token cookie`;
    } else {
      return `Network request failed`;
    }
  } else if (err.TAG === "ServerError") {
    return `HTTP ` + err.status.toString() + ` ` + err.statusText + Stdlib_Option.mapOr(err.response, "", response => ": " + shorten(response));
  } else {
    return `Invalid response: ` + shorten(err._0);
  }
}

function invalidResponse(response) {
  return {
    TAG: "InvalidResponse",
    _0: response
  };
}

function LumiRequest$Error$Notification(props) {
  let __classList = props.classList;
  let error = props.error;
  let classList = __classList !== undefined ? __classList : [[
        "is-danger",
        true
      ]];
  let className = LumiReact.classList([[
      "notification",
      true
    ]].concat(classList));
  let tmp;
  tmp = typeof error !== "object" ? toString(error) : (
      error.TAG === "ServerError" ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("span", {
              children: `HTTP ` + error.status.toString() + ` ` + error.statusText
            }),
            LumiReact.renderOption(undefined, error.response, response => JsxRuntime.jsx("pre", {
              children: response,
              style: {
                whiteSpace: "pre-wrap"
              }
            }))
          ]
        }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("span", {
              children: "Invalid response"
            }),
            JsxRuntime.jsx("pre", {
              children: error._0,
              style: {
                whiteSpace: "pre-wrap"
              }
            })
          ]
        })
    );
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: className,
    onClick: props.onClick
  });
}

let Notification = {
  make: LumiRequest$Error$Notification
};

let $$Error = {
  toString: toString,
  invalidResponse: invalidResponse,
  Notification: Notification
};

function getBodyFromResponse(bodyFromResponse, response) {
  return Future.mapError(FuturePromise.fromPromise(bodyFromResponse(response)), true, param => ({
    TAG: "InvalidResponse",
    _0: "Error reading body"
  }));
}

function make(url, methodOpt, headersOpt, body, param) {
  let method = methodOpt !== undefined ? methodOpt : "GET";
  let headers = headersOpt !== undefined ? headersOpt : ({});
  return {
    url: url,
    method: method,
    headers: headers,
    body: Stdlib_Option.map(body, prim => prim),
    parseResponse: extra => getBodyFromResponse(prim => prim.text(), extra)
  };
}

function sendJSON(req, value, codec) {
  req.headers["Content-Type"] = "application/json;charset=utf-8";
  return {
    url: req.url,
    method: req.method,
    headers: req.headers,
    body: Primitive_option.some(Jzon.encodeStringWith(value, codec)),
    parseResponse: req.parseResponse
  };
}

function expectBody(req, bodyFromResponse) {
  return {
    url: req.url,
    method: req.method,
    headers: req.headers,
    body: req.body,
    parseResponse: extra => getBodyFromResponse(bodyFromResponse, extra)
  };
}

function flatMapWithResponse(req, f) {
  return {
    url: req.url,
    method: req.method,
    headers: req.headers,
    body: req.body,
    parseResponse: response => Future.mapResult(req.parseResponse(response), true, extra => f(response, extra))
  };
}

function mapWithResponse(req, f) {
  return flatMapWithResponse(req, (response, intermediate) => ({
    TAG: "Ok",
    _0: f(response, intermediate)
  }));
}

function flatMapResponse(req, f) {
  return flatMapWithResponse(req, (param, intermediate) => f(intermediate));
}

function mapResponse(req, f) {
  return flatMapWithResponse(req, (param, intermediate) => ({
    TAG: "Ok",
    _0: f(intermediate)
  }));
}

function expectBlob(req) {
  return expectBody(req, prim => prim.blob());
}

function expectJSON(req, codec) {
  req.headers["Accept"] = "application/json;charset=utf-8";
  let req$1 = expectBody(req, prim => prim.json());
  return flatMapWithResponse(req$1, (param, intermediate) => Stdlib_Result.mapError(Stdlib_Result.mapError(Jzon.decodeWith(intermediate, codec), Jzon.DecodingError.toString), invalidResponse));
}

function expectJSONAsAny(req) {
  req.headers["Accept"] = "application/json;charset=utf-8";
  return mapResponse(expectBody(req, prim => prim.json()), x => x);
}

function expectText(req, text) {
  let req$1 = expectBody(req, prim => prim.text());
  return flatMapWithResponse(req$1, (param, intermediate) => {
    if (intermediate === text) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: {
          TAG: "InvalidResponse",
          _0: intermediate
        }
      };
    }
  });
}

function expectNoContent(req) {
  return expectText(req, "");
}

function parseResponseHeader(response, header, parseValue) {
  return Stdlib_Result.flatMap(LumiOption.okOr(Primitive_option.fromNull(response.headers.get(header)), {
    TAG: "InvalidResponse",
    _0: "Missing response header: " + header
  }), str => Stdlib_Result.mapError(parseValue(str), err => ({
    TAG: "InvalidResponse",
    _0: "Invalid value for response header " + header + ": " + err
  })));
}

function parseResponseHeaderJzon(response, header, codec) {
  return parseResponseHeader(response, header, str => Stdlib_Result.mapError(Jzon.decodeStringWith(str, codec), Jzon.DecodingError.toString));
}

function checkStatus(response) {
  let statusText = response.statusText;
  let status = response.status;
  if (status >= 200 && status < 400) {
    return Future.value({
      TAG: "Ok",
      _0: response
    });
  } else {
    return Future.map(FuturePromise.fromPromise(response.text()), true, body => ({
      TAG: "Error",
      _0: {
        TAG: "ServerError",
        status: status,
        statusText: statusText,
        response: Stdlib_Option.flatMap(LumiResult.ok(body), LumiString.nonEmpty)
      }
    }));
  }
}

function send(param) {
  let body = param.body;
  let headers = param.headers;
  let method = param.method;
  let url = param.url;
  return Future.flatMapOk(Future.flatMapOk(Future.make(resolve => {
    let abortController = new AbortController();
    headers["X-XSRF-TOKEN"] = Stdlib_Option.getOr(JsCookieJs.get("XSRF-TOKEN"), "");
    let __x = {
      method: method,
      headers: Primitive_option.some(headers),
      body: body,
      signal: Primitive_option.some(abortController.signal)
    };
    fetch(url, __x).then(ok => resolve({
      TAG: "Ok",
      _0: ok
    }), _exn => resolve({
      TAG: "Error",
      _0: "NetworkRequestFailed"
    }));
    return () => {
      abortController.abort();
    };
  }), true, checkStatus), true, param.parseResponse);
}

function resultFutureEffect(req, onSuccess, onError) {
  return LumiReact.resultFutureEffect(send(req), onSuccess, onError);
}

export {
  $$Error,
  getBodyFromResponse,
  make,
  sendJSON,
  expectBody,
  flatMapWithResponse,
  mapWithResponse,
  flatMapResponse,
  mapResponse,
  expectBlob,
  expectJSON,
  expectJSONAsAny,
  expectText,
  expectNoContent,
  parseResponseHeader,
  parseResponseHeaderJzon,
  checkStatus,
  send,
  resultFutureEffect,
}
/* LumiReact Not a pure module */
